import { __awaiter } from 'tslib';
import { EventEmitter, Component, NgZone, Output, Input, ViewChildren, NgModule } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { CommonModule } from '@angular/common';

import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@angular/platform-browser';
import * as ɵngcc2 from '@angular/common';

const _c0 = ["iframe"];
function NgxDocViewerComponent_ng_container_0_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "div", 3);
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("innerHtml", ctx_r2.docHtml, ɵngcc0.ɵɵsanitizeHtml);
} }
function NgxDocViewerComponent_ng_container_0_object_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "object", 4)(1, "p");
    ɵngcc0.ɵɵtext(2, " Your browser does not support PDFs. ");
    ɵngcc0.ɵɵelementStart(3, "a", 5);
    ɵngcc0.ɵɵtext(4, "Download the PDF");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(5, ". ");
    ɵngcc0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r3 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("data", ctx_r3.fullUrl, ɵngcc0.ɵɵsanitizeResourceUrl);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("href", ctx_r3.fullUrl, ɵngcc0.ɵɵsanitizeUrl);
} }
function NgxDocViewerComponent_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, NgxDocViewerComponent_ng_container_0_div_1_Template, 1, 1, "div", 1);
    ɵngcc0.ɵɵtemplate(2, NgxDocViewerComponent_ng_container_0_object_2_Template, 6, 2, "object", 2);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.configuredViewer !== "pdf");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.fullUrl && ctx_r0.configuredViewer === "pdf");
} }
function NgxDocViewerComponent_ng_container_1_iframe_1_Template(rf, ctx) { if (rf & 1) {
    const _r8 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "iframe", 8, 9);
    ɵngcc0.ɵɵlistener("load", function NgxDocViewerComponent_ng_container_1_iframe_1_Template_iframe_load_0_listener() { ɵngcc0.ɵɵrestoreView(_r8); const ctx_r7 = ɵngcc0.ɵɵnextContext(2); return ɵngcc0.ɵɵresetView(ctx_r7.iframeLoaded()); });
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("src", ctx_r4.fullUrl, ɵngcc0.ɵɵsanitizeResourceUrl);
} }
function NgxDocViewerComponent_ng_container_1_div_2_iframe_2_Template(rf, ctx) { if (rf & 1) {
    const _r12 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "iframe", 12, 9);
    ɵngcc0.ɵɵlistener("load", function NgxDocViewerComponent_ng_container_1_div_2_iframe_2_Template_iframe_load_0_listener() { ɵngcc0.ɵɵrestoreView(_r12); const ctx_r11 = ɵngcc0.ɵɵnextContext(3); return ɵngcc0.ɵɵresetView(ctx_r11.iframeLoaded()); });
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r9 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵproperty("src", ctx_r9.fullUrl, ɵngcc0.ɵɵsanitizeResourceUrl);
} }
function NgxDocViewerComponent_ng_container_1_div_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 10);
    ɵngcc0.ɵɵelement(1, "div");
    ɵngcc0.ɵɵtemplate(2, NgxDocViewerComponent_ng_container_1_div_2_iframe_2_Template, 2, 1, "iframe", 11);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r5 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵstyleProp("background-color", ctx_r5.disableContent === "popout-hide" ? "#fff" : "transparent");
    ɵngcc0.ɵɵclassProp("overlay-full", ctx_r5.disableContent === "all")("overlay-popout-google", ctx_r5.configuredViewer === "google" && (ctx_r5.disableContent === "popout" || ctx_r5.disableContent === "popout-hide"))("overlay-popout-office", ctx_r5.configuredViewer === "office" && (ctx_r5.disableContent === "popout" || ctx_r5.disableContent === "popout-hide"));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r5.fullUrl);
} }
function NgxDocViewerComponent_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, NgxDocViewerComponent_ng_container_1_iframe_1_Template, 2, 1, "iframe", 6);
    ɵngcc0.ɵɵtemplate(2, NgxDocViewerComponent_ng_container_1_div_2_Template, 3, 9, "div", 7);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r1.fullUrl && ctx_r1.disableContent === "none");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r1.disableContent !== "none");
} }
const fileToArray = (url) => {
    return new Promise((resolve, reject) => {
        try {
            const request = new XMLHttpRequest();
            request.open('GET', url, true);
            request.responseType = 'blob';
            request.onload = () => {
                const reader = new FileReader();
                reader.readAsArrayBuffer(request.response);
                reader.onloadend = () => {
                    resolve(reader.result);
                };
            };
            request.send();
        }
        catch (_a) {
            reject(`error while retrieving file ${url}.`);
        }
    });
};
const reloadIFrame = (iframe) => {
    if (iframe) {
        console.log('reloading..');
        // eslint-disable-next-line no-self-assign
        iframe.src = iframe.src;
    }
};
const ɵ0$1 = reloadIFrame;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const handleFileUpload = (fileInput) => {
    return new Promise((resolve, reject) => {
        if (fileInput.target.files && fileInput.target.files[0]) {
            const reader = new FileReader();
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            reader.onload = (e) => {
                resolve(e.target.result);
            };
            reader.readAsDataURL(fileInput.target.files[0]);
        }
        else {
            reject('no files selected');
        }
    });
};
const getbaseUrl = () => {
    const pathArray = window.location.href.split('/');
    const protocol = pathArray[0];
    const host = pathArray[2];
    return protocol + '//' + host;
};
const getLocation = (href) => {
    const match = href.match(/^(https?\:)\/\/(([^:\/?#]*)(?:\:([0-9]+))?)([\/]{0,1}[^?#]*)(\?[^#]*|)(#.*|)$/);
    return match && {
        href,
        protocol: match[1],
        host: match[2],
        hostname: match[3],
        port: match[4],
        pathname: match[5],
        search: match[6],
        hash: match[7]
    };
};
const getDocxToHtml = (url) => __awaiter(void 0, void 0, void 0, function* () {
    if (!mammoth) {
        console.error('Please install mammoth and make sure mammoth.browser.min.js is loaded.');
    }
    const arrayBuffer = yield fileToArray(url);
    const resultObject = yield mammoth.convertToHtml({ arrayBuffer });
    return resultObject.value;
});
const googleCheckSubscription = () => {
    let subscription = null;
    let checkCount = 0;
    return {
        subscribe: (iframe, interval = 3000, maxChecks = 5) => {
            if (!iframeIsLoaded(iframe)) {
                subscription = setInterval(() => {
                    checkCount++;
                    if (checkCount >= maxChecks) {
                        clearInterval(subscription);
                    }
                    reloadIFrame(iframe);
                }, interval);
                return subscription;
            }
            else {
                if (subscription) {
                    clearInterval(subscription);
                }
            }
        },
        unsubscribe: () => {
            if (subscription) {
                clearInterval(subscription);
            }
        },
    };
};
const iframeIsLoaded = (iframe) => {
    var _a;
    // its #document <html><head></head><body></body></html> when google is returning a 204
    // so if contentDocument = null then it's loaded.
    let isLoaded = false;
    try {
        if (!internetExplorer()) {
            isLoaded = !(iframe === null || iframe === void 0 ? void 0 : iframe.contentDocument);
        }
        else {
            isLoaded = !((_a = iframe === null || iframe === void 0 ? void 0 : iframe.contentWindow) === null || _a === void 0 ? void 0 : _a.document);
        }
    }
    catch (_b) {
        // ignore message Blocked a frame with origin "http://..." from accessing a cross-origin frame.
    }
    return isLoaded;
};
const internetExplorer = () => (/MSIE (\d+\.\d+);/.test(navigator.userAgent) || navigator.userAgent.indexOf("Trident/") > -1);
const ɵ1 = internetExplorer;
const getViewerDetails = (url, configuredViewer = 'google', queryParams = '', viewerUrl = '') => {
    switch (configuredViewer) {
        case 'google':
            viewerUrl = `https://docs.google.com/gview?url=%URL%&embedded=true`;
            break;
        case 'office': {
            viewerUrl = `https://view.officeapps.live.com/op/embed.aspx?src=%URL%`;
            break;
        }
        case 'pdf': {
            viewerUrl = '';
            break;
        }
    }
    const externalViewer = configuredViewer === 'google' ||
        configuredViewer === 'office' ||
        configuredViewer === 'url';
    const u = url.indexOf('/') ? encodeURIComponent(url) : url;
    let fullUrl = viewerUrl ? viewerUrl.replace('%URL%', u) : url;
    if (queryParams && externalViewer && configuredViewer !== 'url') {
        const start = queryParams.startsWith('&') ? '' : '&';
        fullUrl = `${fullUrl}${start}${queryParams}`;
    }
    return {
        url: fullUrl,
        externalViewer,
    };
};
const replaceLocalUrl = (url, overrideLocalhost) => {
    const loc = getLocation(url);
    const locReplace = getLocation(overrideLocalhost);
    if (loc && locReplace) {
        return url.replace(loc.port ? `${loc.hostname}:${loc.port}` : loc.hostname, locReplace.port ? `${locReplace.hostname}:${locReplace.port}` : locReplace.hostname);
    }
    return url;
};
const getBlobFromUrl = (url) => {
    return new Promise((resolve, reject) => {
        let request = new XMLHttpRequest();
        request.open('GET', url, true);
        request.responseType = 'blob';
        request.onload = () => {
            resolve(request.response);
        };
        request.onerror = reject;
        request.send();
    });
};
const ɵ2 = getBlobFromUrl;
const uploadToCloud = (fileUrl, api) => new Promise((resolve, reject) => {
    getBlobFromUrl(fileUrl).then(blob => {
        var _a, _b;
        const loc = getLocation(fileUrl);
        const name = (loc === null || loc === void 0 ? void 0 : loc.pathname) ? (_a = loc === null || loc === void 0 ? void 0 : loc.pathname) === null || _a === void 0 ? void 0 : _a.split('/')[((_b = loc === null || loc === void 0 ? void 0 : loc.pathname) === null || _b === void 0 ? void 0 : _b.split('/').length) - 1] : '';
        const formData = new FormData();
        const request = new XMLHttpRequest();
        formData.append('file', blob, name);
        request.onreadystatechange = e => {
            if (request.readyState === XMLHttpRequest.DONE) {
                if (request.status === 200) {
                    resolve(request.responseText);
                }
                else {
                    reject(request.responseText);
                }
            }
        };
        request.onerror = reject;
        request.open('post', api, true);
        request.send(formData);
    });
});
const isLocalFile = (file) => {
    const loc = getLocation(file);
    const hostname = (loc === null || loc === void 0 ? void 0 : loc.hostname) || '';
    return ((['localhost', '127.0.0.1', '', '::1'].includes(hostname))
        || (hostname.startsWith('192.168.'))
        || (hostname.startsWith('10.0.'))
        || (hostname.endsWith('.local')));
};

class NgxDocViewerComponent {
    constructor(domSanitizer, ngZone) {
        this.domSanitizer = domSanitizer;
        this.ngZone = ngZone;
        this.loaded = new EventEmitter();
        this.url = '';
        this.queryParams = '';
        this.viewerUrl = '';
        this.googleCheckInterval = 3000;
        this.googleMaxChecks = 5;
        this.disableContent = 'none';
        this.googleCheckContentLoaded = true;
        this.fullUrl = null;
        this.externalViewer = false;
        this.docHtml = '';
        this.configuredViewer = 'google';
        this.shouldCheckIframe = false;
    }
    ngAfterViewInit() {
        var _a, _b;
        if (this.shouldCheckIframe) {
            const iframe = (_b = (_a = this.iframes) === null || _a === void 0 ? void 0 : _a.first) === null || _b === void 0 ? void 0 : _b.nativeElement;
            if (iframe) {
                this.shouldCheckIframe = false;
                this.reloadIframe(iframe);
            }
        }
    }
    ngOnDestroy() {
        if (this.checkIFrameSubscription) {
            this.checkIFrameSubscription.unsubscribe();
        }
    }
    ngOnChanges(changes) {
        return __awaiter(this, void 0, void 0, function* () {
            if (changes &&
                changes.viewer &&
                (changes.viewer.isFirstChange ||
                    changes.viewer.currentValue !== changes.viewer.previousValue)) {
                if (this.viewer !== 'google' &&
                    this.viewer !== 'office' &&
                    this.viewer !== 'mammoth' &&
                    this.viewer !== 'pdf' &&
                    this.viewer !== 'url') {
                    console.error(`Unsupported viewer: '${this.viewer}'. Supported viewers: google, office, mammoth and pdf`);
                }
                this.configuredViewer = this.viewer;
            }
            if ((changes.url && changes.url.currentValue !== changes.url.previousValue) ||
                (changes.viewer &&
                    changes.viewer.currentValue !== changes.viewer.previousValue) ||
                (changes.viewerUrl &&
                    changes.viewerUrl.currentValue !== changes.viewerUrl.previousValue)) {
                let viewerDetails = getViewerDetails(this.url, this.configuredViewer, this.queryParams, this.viewerUrl);
                this.externalViewer = viewerDetails.externalViewer;
                if (viewerDetails.externalViewer && this.overrideLocalhost && isLocalFile(this.url)) {
                    const newUrl = replaceLocalUrl(this.url, this.overrideLocalhost);
                    viewerDetails = getViewerDetails(newUrl, this.configuredViewer, this.queryParams, this.viewerUrl);
                }
                this.docHtml = '';
                if (this.checkIFrameSubscription) {
                    this.checkIFrameSubscription.unsubscribe();
                }
                if (!this.url) {
                    this.fullUrl = null;
                }
                else if (viewerDetails.externalViewer ||
                    this.configuredViewer === 'url') {
                    this.fullUrl = this.domSanitizer.bypassSecurityTrustResourceUrl(viewerDetails.url);
                    // see:
                    // https://stackoverflow.com/questions/40414039/google-docs-viewer-returning-204-responses-no-longer-working-alternatives
                    // hack to reload iframe if it's not loaded.
                    // would maybe be better to use view.officeapps.live.com but seems not to work with sas token.
                    if (this.configuredViewer === 'google' &&
                        this.googleCheckContentLoaded) {
                        this.ngZone.runOutsideAngular(() => {
                            var _a, _b;
                            // if it's not loaded after the googleIntervalCheck, then open load again.
                            const iframe = (_b = (_a = this.iframes) === null || _a === void 0 ? void 0 : _a.first) === null || _b === void 0 ? void 0 : _b.nativeElement;
                            if (iframe) {
                                this.reloadIframe(iframe);
                            }
                            else {
                                this.shouldCheckIframe = true;
                            }
                        });
                    }
                }
                else if (this.configuredViewer === 'mammoth') {
                    this.docHtml = yield getDocxToHtml(this.url);
                }
            }
        });
    }
    reloadIframe(iframe) {
        this.checkIFrameSubscription = googleCheckSubscription();
        this.checkIFrameSubscription.subscribe(iframe, this.googleCheckInterval, this.googleMaxChecks);
    }
    iframeLoaded() {
        var _a, _b;
        const iframe = (_b = (_a = this.iframes) === null || _a === void 0 ? void 0 : _a.first) === null || _b === void 0 ? void 0 : _b.nativeElement;
        if (iframe && iframeIsLoaded(iframe)) {
            this.loaded.emit(null);
            if (this.checkIFrameSubscription) {
                this.checkIFrameSubscription.unsubscribe();
            }
        }
    }
}
NgxDocViewerComponent.ɵfac = function NgxDocViewerComponent_Factory(t) { return new (t || NgxDocViewerComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc1.DomSanitizer), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone)); };
NgxDocViewerComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: NgxDocViewerComponent, selectors: [["ngx-doc-viewer"]], viewQuery: function NgxDocViewerComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c0, 5);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.iframes = _t);
    } }, inputs: { url: "url", queryParams: "queryParams", viewerUrl: "viewerUrl", googleCheckInterval: "googleCheckInterval", googleMaxChecks: "googleMaxChecks", disableContent: "disableContent", googleCheckContentLoaded: "googleCheckContentLoaded", viewer: "viewer", overrideLocalhost: "overrideLocalhost" }, outputs: { loaded: "loaded" }, features: [ɵngcc0.ɵɵNgOnChangesFeature], decls: 2, vars: 2, consts: [[4, "ngIf"], [3, "innerHtml", 4, "ngIf"], ["type", "application/pdf", "width", "100%", "height", "100%", 3, "data", 4, "ngIf"], [3, "innerHtml"], ["type", "application/pdf", "width", "100%", "height", "100%", 3, "data"], [3, "href"], ["id", "iframe-doc-viewer", "frameBorder", "0", 3, "src", "load", 4, "ngIf"], ["class", "container", 4, "ngIf"], ["id", "iframe-doc-viewer", "frameBorder", "0", 3, "src", "load"], ["iframe", ""], [1, "container"], ["id", "iframe", "frameBorder", "0", 3, "src", "load", 4, "ngIf"], ["id", "iframe", "frameBorder", "0", 3, "src", "load"]], template: function NgxDocViewerComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, NgxDocViewerComponent_ng_container_0_Template, 3, 2, "ng-container", 0);
        ɵngcc0.ɵɵtemplate(1, NgxDocViewerComponent_ng_container_1_Template, 3, 2, "ng-container", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", !ctx.externalViewer);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.externalViewer);
    } }, dependencies: [ɵngcc2.NgIf], styles: ["[_nghost-%COMP%] {\n        display: block;\n      }\n      .container[_ngcontent-%COMP%] {\n        width: 100%;\n        height: 100%;\n        position: relative;\n      }\n      .overlay-popout-google[_ngcontent-%COMP%] {\n        width: 40px;\n        height: 40px;\n        right: 26px;\n        top: 11.5px;\n        position: absolute;\n        z-index: 1000;\n      }\n      .overlay-popout-office[_ngcontent-%COMP%] {\n        width: 100px;\n        height: 20px;\n        right: 0;\n        bottom: 0;\n        position: absolute;\n        z-index: 1000;\n      }\n      .overlay-full[_ngcontent-%COMP%] {\n        width: 100%;\n        height: 100%;\n        right: 0;\n        top: 0;\n        position: absolute;\n        z-index: 1000;\n      }\n      iframe[_ngcontent-%COMP%] {\n        width: 100%;\n        height: 100%;\n      }"] });
NgxDocViewerComponent.ctorParameters = () => [
    { type: DomSanitizer },
    { type: NgZone }
];
NgxDocViewerComponent.propDecorators = {
    loaded: [{ type: Output }],
    url: [{ type: Input }],
    queryParams: [{ type: Input }],
    viewerUrl: [{ type: Input }],
    googleCheckInterval: [{ type: Input }],
    googleMaxChecks: [{ type: Input }],
    disableContent: [{ type: Input }],
    googleCheckContentLoaded: [{ type: Input }],
    viewer: [{ type: Input }],
    overrideLocalhost: [{ type: Input }],
    iframes: [{ type: ViewChildren, args: ['iframe',] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NgxDocViewerComponent, [{
        type: Component,
        args: [{ selector: 'ngx-doc-viewer', template: "<ng-container *ngIf=\"!externalViewer\">\r\n  <div *ngIf=\"configuredViewer !== 'pdf'\" [innerHtml]=\"docHtml\"></div>\r\n  <object\r\n    *ngIf=\"fullUrl && configuredViewer === 'pdf'\"\r\n    [data]=\"fullUrl\"\r\n    type=\"application/pdf\"\r\n    width=\"100%\"\r\n    height=\"100%\"\r\n  >\r\n    <p>\r\n      Your browser does not support PDFs.\r\n      <a [href]=\"fullUrl\">Download the PDF</a>.\r\n    </p>\r\n  </object>\r\n</ng-container>\r\n<ng-container *ngIf=\"externalViewer\">\r\n  <iframe\r\n    (load)=\"iframeLoaded()\"\r\n    *ngIf=\"fullUrl && disableContent === 'none'\"\r\n    #iframe\r\n    id=\"iframe-doc-viewer\"\r\n    frameBorder=\"0\"\r\n    [src]=\"fullUrl\"\r\n  ></iframe>\r\n  <div class=\"container\" *ngIf=\"disableContent !== 'none'\">\r\n    <div\r\n      [class.overlay-full]=\"disableContent === 'all'\"\r\n      [class.overlay-popout-google]=\"\r\n        configuredViewer === 'google' &&\r\n        (disableContent === 'popout' || disableContent === 'popout-hide')\r\n      \"\r\n      [class.overlay-popout-office]=\"\r\n        configuredViewer === 'office' &&\r\n        (disableContent === 'popout' || disableContent === 'popout-hide')\r\n      \"\r\n      [style.background-color]=\"\r\n        disableContent === 'popout-hide' ? '#fff' : 'transparent'\r\n      \"\r\n    ></div>\r\n    <iframe\r\n      (load)=\"iframeLoaded()\"\r\n      *ngIf=\"fullUrl\"\r\n      #iframe\r\n      id=\"iframe\"\r\n      frameBorder=\"0\"\r\n      [src]=\"fullUrl\"\r\n    ></iframe>\r\n  </div>\r\n</ng-container>\r\n", styles: ["\n      :host {\n        display: block;\n      }\n      .container {\n        width: 100%;\n        height: 100%;\n        position: relative;\n      }\n      .overlay-popout-google {\n        width: 40px;\n        height: 40px;\n        right: 26px;\n        top: 11.5px;\n        position: absolute;\n        z-index: 1000;\n      }\n      .overlay-popout-office {\n        width: 100px;\n        height: 20px;\n        right: 0;\n        bottom: 0;\n        position: absolute;\n        z-index: 1000;\n      }\n      .overlay-full {\n        width: 100%;\n        height: 100%;\n        right: 0;\n        top: 0;\n        position: absolute;\n        z-index: 1000;\n      }\n      iframe {\n        width: 100%;\n        height: 100%;\n      }\n    "] }]
    }], function () { return [{ type: ɵngcc1.DomSanitizer }, { type: ɵngcc0.NgZone }]; }, { loaded: [{
            type: Output
        }], url: [{
            type: Input
        }], queryParams: [{
            type: Input
        }], viewerUrl: [{
            type: Input
        }], googleCheckInterval: [{
            type: Input
        }], googleMaxChecks: [{
            type: Input
        }], disableContent: [{
            type: Input
        }], googleCheckContentLoaded: [{
            type: Input
        }], viewer: [{
            type: Input
        }], overrideLocalhost: [{
            type: Input
        }], iframes: [{
            type: ViewChildren,
            args: ['iframe']
        }] }); })();

class NgxDocViewerModule {
}
NgxDocViewerModule.ɵfac = function NgxDocViewerModule_Factory(t) { return new (t || NgxDocViewerModule)(); };
NgxDocViewerModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: NgxDocViewerModule });
NgxDocViewerModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [CommonModule] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NgxDocViewerModule, [{
        type: NgModule,
        args: [{
                imports: [CommonModule],
                declarations: [NgxDocViewerComponent],
                exports: [NgxDocViewerComponent]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(NgxDocViewerModule, { declarations: function () { return [NgxDocViewerComponent]; }, imports: function () { return [CommonModule]; }, exports: function () { return [NgxDocViewerComponent]; } }); })();

const ɵ0 = () => { };
const defaultProps = {
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    loaded: ɵ0,
    disableContent: 'none',
    googleCheckContentLoaded: true,
    googleCheckInterval: 3000,
    queryParams: '',
    url: '',
    viewer: 'google',
    viewerUrl: '',
};

/**
 * Generated bundle index. Do not edit.
 */

export { NgxDocViewerComponent, NgxDocViewerModule, defaultProps, fileToArray, getDocxToHtml, getLocation, getViewerDetails, getbaseUrl, googleCheckSubscription, handleFileUpload, iframeIsLoaded, isLocalFile, replaceLocalUrl, uploadToCloud, ɵ0$1 as ɵ0, ɵ1, ɵ2 };

